export const MB = 1024 * 1024;

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * MB;
export const MAX_EMAIL_SIZE_MB = 10;
export const MAX_EMAIL_SIZE_BYTES = MAX_EMAIL_SIZE_MB * MB;

export const MAX_ATTACHMENT_COUNT = 10;
export const MAX_MBFILE_SIZE_MB = 10;
export const MAX_MBATTACHMENT_COUNT = 1;
export const MAX_MBFILE_SIZE_BYTES = MAX_MBFILE_SIZE_MB * MB;

export const ALLOWED_EXTENSIONS = new Set([
  'csv',
  'doc',
  'docx',
  'gif',
  'heic',
  'jpeg',
  'jpg',
  'mov',
  'mp4',
  'pdf',
  'png',
  'ppt',
  'pptx',
  'txt',
  'xls',
  'xlsx',
  'zip',
]);
